import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { TranslateModule } from '@ngx-translate/core';
import { User } from 'app/profile/profile.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { SelectFormFieldComponent } from '../fields/select-form-field/select-form-field.component';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';

@Component({
  selector: 'app-personal-information-form',
  standalone: true,
  imports: [ReactiveFormsModule, InputFormFieldComponent, SelectFormFieldComponent, TranslateModule, ConfigurationSelectFormFieldComponent],
  templateUrl: './personal-information.component.html',
  styleUrl: './personal-information.component.scss'
})
export class PersonalInformationComponent {
  personalInfoForm!: FormGroup;
  @Input() userData!: User;
  globalCustomers: any[] = [];
  dropdownGlobalCustomers = DropdownTypeEnum.CUSTOMER_INFORMATION;
  
  constructor(private fb: FormBuilder, private configurationService: ConfigurationService) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.personalInfoForm = this.fb.group({
      email: [{ value: this.userData?.email, disabled: true }],
      department: [{ value: this.userData?.department, disabled: true }],
      contactPhone: [{ value: this.userData?.contactPhone, disabled: true }],
      globalCustomerName: [this.userData?.globalCustomerName || '']
    });
  }

  resetForm(): void {
    this.personalInfoForm.reset({
      email: { value: this.userData?.email, disabled: true },
      department: { value: this.userData?.department, disabled: true },
      contactPhone: { value: this.userData?.contactPhone, disabled: true },
      globalCustomerName: this.userData?.globalCustomerName || ''
    });
    this.personalInfoForm.markAsPristine();
  }

  get globalCustomerName(): string {
    return this.personalInfoForm.get('globalCustomerName')?.value || '';
  }

  get isGlobalCustomerNameDirty(): boolean {
    return this.personalInfoForm.get('globalCustomerName')?.dirty || false;
  }
}
